/**
 * Build display `images` after PATCH so the profile hero updates immediately.
 * Uses editor preview data URLs for newly picked files (server paths may lag or 404 briefly).
 */
export function buildAssetUpdateDisplayImages(
  wirePaths: readonly string[],
  alignedFiles: readonly (File | undefined)[],
  previewSrcs: readonly (string | undefined)[],
): string[] {
  const len = Math.max(wirePaths.length, alignedFiles.length, previewSrcs.length);
  const out: string[] = [];
  for (let i = 0; i < len; i++) {
    const preview = previewSrcs[i]?.trim();
    if (alignedFiles[i] && preview) {
      out.push(preview);
      continue;
    }
    const path = wirePaths[i]?.trim();
    if (path) {
      out.push(path);
    }
  }
  return out;
}

export function applyUploadedImagePreviewsToAssetRecord(
  record: Record<string, unknown>,
  wirePaths: readonly string[],
  alignedFiles: readonly (File | undefined)[],
  previewSrcs: readonly (string | undefined)[],
): Record<string, unknown> {
  const hadUpload = alignedFiles.some(Boolean);
  if (!hadUpload) {
    return record;
  }
  const images = buildAssetUpdateDisplayImages(wirePaths, alignedFiles, previewSrcs);
  if (images.length === 0) {
    return record;
  }
  return { ...record, images };
}
